import { Recording } from '@hotjar/webapp/domains/recordings/types';
import { moment } from '@hotjar/webapp/lib/moment';
import { useTranslation } from 'react-i18next';

export const useCreateTimeAgoLabelFromRecording = (recording?: Recording) => {
  const { t } = useTranslation();

  if (!recording || !recording.created) return;

  const formattedTimeAgo = moment.unix(recording.created).fromNow(true).split(' ');
  const [value, timeUnit] = formattedTimeAgo;

  return Number.isNaN(Number(value)) // fe. "AN hour"
    ? t(`common:recordings.recordings-overview.widget.cells.created.${formattedTimeAgo.join('-')}`)
    : `${value} ${t(`common:recordings.recordings-overview.widget.cells.created.${timeUnit}`)}`;
};
